import React from 'react';
import './Quotes.scss';
import quoteData from './quoteData';

function Quotes({ index, origin }) {
  return (
    <div className={origin === 'sidebar' ? 'quotes quotes--sidebar' : 'quotes'}>
      <div
        className={index === 1 ? 'quotes__portrait quotes__portrait--shadow' : 'quotes__portrait'}
      >
        <img src={quoteData[index].image} alt="" className="quotes__portrait__img" />
      </div>
      <div className={origin === 'sidebar' ? 'quotes__copy quotes__copy--sidebar' : 'quotes__copy'}>
        <blockquote className="quotes__copy-text">{quoteData[index].copy}</blockquote>
        <div className="quotes__by">
          {quoteData[index].name}{' '}
          <span className="quotes__by quotes__by--title">{quoteData[index].title}</span>
        </div>
      </div>
    </div>
  );
}

export default Quotes;
